import { useState } from 'react';
import { Card, Col, Row, Select, Space, Switch, Typography } from 'antd';
import ReferencePicker from '@components/forms/ReferencePicker';
import { acqListReferenceTypes } from '@components/forms/referenceTypes';

/**
 * Тестова сторінка для ReferencePicker.
 * Admin → "Тест ReferencePicker": можна обрати тип довідника,
 * перевірити пошук, побачити обране value (id + label),
 * перемикнути read-only режим.
 *
 * Сторінка тимчасова — буде видалена після Phase 4 (інтеграція ReferencePicker
 * у BasFormRenderer через нормалізований FormSchema).
 */
export default function ReferencePickerTestPage() {
  const [acqType, setAcqType] = useState<string>('counterparty');
  const [acqValue, setAcqValue] = useState<string | null>(null);
  const [acqLabel, setAcqLabel] = useState<string>('');
  const [acqReadOnly, setAcqReadOnly] = useState(false);
  const acqTypes = acqListReferenceTypes();

  return (
    <Space direction="vertical" size={16} style={{ width: '100%', maxWidth: 800 }}>
      <Typography.Title level={4} style={{ marginBottom: 0 }}>
        Тест ReferencePicker
      </Typography.Title>
      <Typography.Text type="secondary">
        Перевірка асинхронного пошуку по серверних довідниках. Введіть текст у Select —
        запит йде на <code>GET /api/{'{type}'}?search=…</code> з дебаунсом 250 ms.
      </Typography.Text>

      <Card size="small">
        <Row gutter={16} align="middle">
          <Col span={8}>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>Тип довідника</Typography.Text>
            <Select
              value={acqType}
              onChange={(v) => { setAcqType(v); setAcqValue(null); setAcqLabel(''); }}
              options={acqTypes}
              style={{ width: '100%' }}
              showSearch
              optionFilterProp="label"
            />
          </Col>
          <Col span={6}>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>Read-only</Typography.Text>
            <div style={{ paddingTop: 4 }}>
              <Switch checked={acqReadOnly} onChange={setAcqReadOnly} />
            </div>
          </Col>
        </Row>
      </Card>

      <Card size="small" title="ReferencePicker">
        <ReferencePicker
          acqReferenceType={acqType}
          acqValue={acqValue}
          acqOnChange={(id, label) => {
            setAcqValue(id);
            setAcqLabel(label ?? '');
          }}
          acqReadOnly={acqReadOnly}
        />
      </Card>

      <Card size="small" title="Стан">
        <Space direction="vertical">
          <Typography.Text>
            <strong>id:</strong> <code>{acqValue ?? '—'}</code>
          </Typography.Text>
          <Typography.Text>
            <strong>label:</strong> {acqLabel || '—'}
          </Typography.Text>
        </Space>
      </Card>
    </Space>
  );
}
